var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSetting = function SvgSetting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 5,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.186,
    cy: 2.186,
    r: 2.186,
    fill: "#000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.557,
    cy: 2.186,
    r: 2.186,
    fill: "#000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.928,
    cy: 2.186,
    r: 2.186,
    fill: "#000"
  })));
};
export default SvgSetting;